import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import { Box, Button, Dialog, Link, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

const LOCAL_STORAGE_KEY = "transp_comarr_info_11062026";

import csLogo from "../../assets/favicon.png";
import background from "../../assets/komunikat-info.jpg";

export const PromotionDialog = () => {
	const { t, i18n } = useTranslation();
	const currentLang = i18n?.language || "pl";
	const [openPromotionPopup, setOpenPromotionPopup] = useState(false);

	// lock close button for 5 seconds
	const [lockCloseButton, setLockCloseButton] = useState(true);
	const [lockCounter, setLockCounter] = useState(5);

	// unlock button after 5 seconds
	useEffect(() => {
		if (lockCounter === 0) {
			setLockCloseButton(false);
			return;
		}

		const interval = setInterval(() => {
			setLockCounter((prev) => prev - 1);
		}, 1000);

		return () => clearInterval(interval);
	}, [lockCounter]);

	// show promotion popup only if today is the same or after the promotion date
	useEffect(() => {
		if (localStorage.getItem(LOCAL_STORAGE_KEY) !== "true") {
			setOpenPromotionPopup(true);
			localStorage.setItem(LOCAL_STORAGE_KEY, "true");
		}
	}, []);

	return (
		<Dialog
			fullWidth
			maxWidth="md"
			onClose={(_e, reason) => {
				if (reason === "backdropClick") return;
				setOpenPromotionPopup(false);
			}}
			open={openPromotionPopup}
			disableEscapeKeyDown={true}
		>
			<Box
				sx={{
					padding: "30px 30px",
					background: `url(${background}) no-repeat center/cover`,
					position: "relative",
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						position: "absolute",
						top: 0,
						right: "20px",
						background: "#4d4d4d",
						borderBottomLeftRadius: "8px",
						borderBottomRightRadius: "8px",
						padding: "3px 2px",
						overflow: "hidden",
					}}
				>
					<img src={csLogo} alt="CARGOseller Logo" width={40} />
				</Box>
				{currentLang === "pl" ? <PLContent /> : <ENContent />}
				<Box
					sx={{
						width: "100%",
						display: "flex",
						justifyContent: "center",
						gap: "20px",
						marginTop: "30px",
					}}
				>
					<Button
						variant="contained"
						color="error"
						disabled={lockCloseButton}
						onClick={() => setOpenPromotionPopup(false)}
						sx={{
							textTransform: "uppercase",
							background: "#585858",
							"&:hover": {
								background: "#474646",
							},
						}}
					>
						{t("close")} {lockCounter > 0 && `(${lockCounter})`}
					</Button>
				</Box>
			</Box>
		</Dialog>
	);
};

const PLContent = () => {
	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Typography variant="h2" sx={{ fontWeight: "600", color: "#ed1d79" }}>
					2 NOWE GIEŁDY
				</Typography>
				<Typography
					variant="body1"
					sx={{ mt: "8px", fontSize: "22px", color: "#333333" }}
				>
					Zintegrowaliśmy 2 nowe giełdy, aby pomóc Ci w skutecznej sprzedaży
					ładunków. To nowe możliwości docierania ze swoimi ładunkami do nowych
					odbiorców bez poświęcania na to dodatkowego czasu. Jakie giełdy
					zintegrowaliśmy?
				</Typography>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						gap: "10px",
						marginTop: "20px",
					}}
				>
					<ArrowCircleUpIcon
						sx={{ fontSize: 40, color: "#29a9e1", transform: "rotate(90deg)" }}
					/>
					<Typography variant="h3" sx={{ color: "#333333" }}>
						COMARR.CZ
					</Typography>
				</Box>
				<Typography
					variant="body1"
					sx={{ marginTop: "10px", fontSize: "20px", ml: "52px" }}
				>
					Lider na rynkach CZ & SK, a więc nowe źródło pozyskiwania
					przewoźników, dla których giełdą pierwszego wyboru jest właśnie
					lokalna giełda Comarr. Od teraz możesz publikować na tą giełdę i
					pokazać swoje ładunki większej liczbie przewoźników. Niskie opłaty i
					krótki czas umowy oferowane przez giełdę Comarr to istotna zaleta.
				</Typography>
				<Box sx={{ ml: "52px", marginTop: "14px" }}>
					<Link asChild href="https://spedice.comarr.cz/en/" target="_blank">
						<Button variant="contained">Przejdź do Comarr</Button>
					</Link>
				</Box>
			</Box>
			<Box sx={{ marginTop: "20px" }}>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "10px",
						marginTop: "20px",
					}}
				>
					<ArrowCircleUpIcon
						sx={{ fontSize: 40, color: "#29a9e1", transform: "rotate(90deg)" }}
					/>
					<Typography variant="h3" sx={{ color: "#333333" }}>
						TRANSPOREON (SPOT)
					</Typography>
				</div>
				<Typography
					variant="body1"
					sx={{ marginTop: "10px", fontSize: "20px", ml: "52px" }}
				>
					Z przyjemnością informujemy, że Transporeon Freight Exchange (giełda
					transportowa/spot) jest również zintegrowany z naszym systemem. Warto
					nadmienić, że giełda jest bezpłatna dla firm oferujących ładunki.
					Integracja pozwala zarządzać ofertami z naszego systemu, a więc bez
					poświęcania na to dodatkowego czasu. O bezpłatny dostęp można
					wnioskować tutaj:
				</Typography>
				<Box sx={{ ml: "52px", marginTop: "14px" }}>
					<Link
						asChild
						href="https://docs.google.com/forms/d/e/1FAIpQLSdjaIVIeJl3nhhYeV0DUMsHJzTHm8n8CTpNi4QkQDDDQPwywg/viewform"
						target="_blank"
					>
						<Button variant="contained">Wnioskuj teraz</Button>
					</Link>
				</Box>
			</Box>
		</>
	);
};

const ENContent = () => {
	return (
		<>
			<Box sx={{ position: "relative" }}>
				<Typography variant="h2" sx={{ fontWeight: "600", color: "#ed1d79" }}>
					2 NEW MARKETPLACES
				</Typography>
				<Typography
					variant="body1"
					sx={{ mt: "8px", fontSize: "22px", color: "#333333" }}
				>
					We have integrated 2 new freight exchanges to help you sell your cargo
					effectively. These are new opportunities to reach new carriers with
					your cargo without spending extra time. Which&nbsp;freight exchanges
					have we integrated?
				</Typography>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						gap: "10px",
						marginTop: "20px",
					}}
				>
					<ArrowCircleUpIcon
						sx={{ fontSize: 40, color: "#29a9e1", transform: "rotate(90deg)" }}
					/>
					<Typography variant="h3" sx={{ color: "#333333" }}>
						COMARR.CZ
					</Typography>
				</Box>
				<Typography
					variant="body1"
					sx={{ marginTop: "10px", fontSize: "20px", ml: "52px" }}
				>
					A leader in the CZ & SK markets, it’s a new source of carriers for
					whom the local Comarr freight exchange is their first choice. From now
					on, you can publish your loads on this exchange and expose them to
					more carriers. The low monthly fees and short contract terms offered
					by Comarr are a significant advantage.
				</Typography>
				<Box sx={{ ml: "52px", marginTop: "14px" }}>
					<Link asChild href="https://spedice.comarr.cz/en/" target="_blank">
						<Button variant="contained">Go to Comarr</Button>
					</Link>
				</Box>
			</Box>
			<Box sx={{ marginTop: "20px" }}>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "10px",
						marginTop: "20px",
					}}
				>
					<ArrowCircleUpIcon
						sx={{ fontSize: 40, color: "#29a9e1", transform: "rotate(90deg)" }}
					/>
					<Typography variant="h3" sx={{ color: "#333333" }}>
						TRANSPOREON (SPOT)
					</Typography>
				</div>
				<Typography
					variant="body1"
					sx={{ marginTop: "10px", fontSize: "20px", ml: "52px" }}
				>
					We are pleased to announce that Transporeon Freight Exchange is also
					integrated with our system. It’s worth noting that the freight
					exchange is free for companies offering freight offers. Integration
					allows you to manage offers from our system, so without additional
					effort. You can apply for free access here:
				</Typography>
				<Box sx={{ ml: "52px", marginTop: "14px" }}>
					<Link
						asChild
						href="https://docs.google.com/forms/d/e/1FAIpQLSdjaIVIeJl3nhhYeV0DUMsHJzTHm8n8CTpNi4QkQDDDQPwywg/viewform"
						target="_blank"
					>
						<Button variant="contained">Apply Now</Button>
					</Link>
				</Box>
			</Box>
		</>
	);
};
